import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import { setSubroute } from 'store/navbar'
import { setPageTitle } from 'utils/misc'
import { fetchStudy } from '../../../CreateStudy/modules/CreateStudy'
import ClinroIframeContainer from './containers/ClinroIframeContainer'

// Sync route definition
export default store => ({
    path: 'clinro',
    exact: true,
    getComponent(nextState, cb) {
        require.ensure(
            [],
            require => {
                const { params } = nextState
                const { studyID, studyVersionID } = params
                const { currentStudy } = store.getState().study

                store.dispatch(setSubroute('clinro'))
                store.dispatch(fetchStudy(studyID))
                setPageTitle(`ClinRO | Study ${studyID} | ${currentStudy.platform_name}`)

                cb(
                    null,
                    UserIsAuthenticated(
                        UserHasValidPassword(
                            UserHasScope(['wpv', 'rpv'], ClinroIframeContainer, false, studyID),
                        ),
                    ),
                )
            },
            'clinro',
        )
    },
})

